const Heading = {
  baseStyle: {
    color: "pureBlack",
    fontSize: "heading.xl"
  }
};

export default Heading;